import { useFilters } from "@/hooks/useFilters";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { TIME_FILTERS } from "@/lib/constants";

export default function TimeFilterButtons({
  setShowTimeMenu,
  className = "",
}: {
  setShowTimeMenu: (show: boolean) => void;
  className?: string;
}) {
  const { timeFilter, setTimeFilter, resetTimeFilter } = useFilters();
  const timeFilterRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(timeFilterRef as React.RefObject<HTMLElement>, () => {
    setShowTimeMenu(false);
  });

  return (
    <div
      ref={timeFilterRef}
      className={className}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {Object.keys(TIME_FILTERS).map((t) => {
        const v = t === "all" ? "" : t;
        return (
          <button
            key={t}
            onClick={() => {
              if (t === "all") {
                resetTimeFilter();
              } else {
                setTimeFilter(t as keyof typeof TIME_FILTERS);
              }
              setShowTimeMenu(false);
            }}
            className={`w-full px-4 py-2 text-left text-sm hover:bg-muted ${
              timeFilter === v ? "text-[#01B9D9] font-medium" : "text-foreground"
            }`}
          >
            {TIME_FILTERS[t as keyof typeof TIME_FILTERS]}
          </button>
        );
      })}
    </div>
  );
}
